export default __webpack_public_path__ + "static/media/img3.6e2aef22.png";